import React, { useState, useEffect } from 'react';
import OrcamentoList from './OrcamentoList';
import EnderecoEntregaList from './EnderecoEntregaList';
import AnexosOrcamentoList from './AnexosOrcamentoList';
import OrcamentosTab from './orcamentos/OrcamentosTab';

interface OrcamentoTabsProps {
    opportunityId: number;
    etapaAtual: number;
    funilAtual: number;
    formatCurrency: (value: number | string) => string;
    onUpdateComplete: () => void;
    // Muda quando a página pai alterou a oportunidade (ex.: edição), para todas as abas recarregarem
    externalRefreshKey?: number;
}

const OrcamentoTabs: React.FC<OrcamentoTabsProps> = ({
    opportunityId,
    etapaAtual,
    funilAtual,
    formatCurrency,
    onUpdateComplete,
    externalRefreshKey = 0
}) => {
    const [activeTab, setActiveTab] = useState('orcamento');

    // As abas internas carregam seus dados só ao montar. Estes contadores avisam
    // as outras abas quando algo muda, para atualizarem sem recarregar a página.
    // - listaRefreshKey: consumido por "Itens do Orçamento" (muda quando "Detalhes dos Orçamentos" altera algo)
    // - outrasAbasRefreshKey: consumido por "Detalhes dos Orçamentos" e "Anexos" (muda quando "Itens" altera algo)
    const [listaRefreshKey, setListaRefreshKey] = useState(0);
    const [outrasAbasRefreshKey, setOutrasAbasRefreshKey] = useState(0);

    // Mudança vinda da página pai: recarrega todas as abas internas
    useEffect(() => {
        if (externalRefreshKey > 0) {
            setListaRefreshKey(k => k + 1);
            setOutrasAbasRefreshKey(k => k + 1);
        }
    }, [externalRefreshKey]);

    const handleListaUpdate = () => {
        setOutrasAbasRefreshKey(k => k + 1);
        onUpdateComplete();
    };

    const handleOrcamentosUpdate = () => {
        setListaRefreshKey(k => k + 1);
        onUpdateComplete();
    };

    return (
        <div className="card">
            <div className="card-header pb-0">
                <ul className="nav nav-tabs nav-tabs-bordered">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'orcamento' ? 'active' : ''}`}
                            onClick={() => setActiveTab('orcamento')}
                        >
                            <i className="ti ti-calculator me-1"></i>
                            Itens do Orçamento
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'detalhes_orcamentos' ? 'active' : ''}`}
                            onClick={() => setActiveTab('detalhes_orcamentos')}
                        >
                            <i className="ti ti-files me-1"></i>
                            Detalhes dos Orçamentos
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'anexos_orcamento' ? 'active' : ''}`}
                            onClick={() => setActiveTab('anexos_orcamento')}
                        >
                            <i className="ti ti-file-invoice me-1"></i>
                            Anexos de Orçamento
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'enderecos' ? 'active' : ''}`}
                            onClick={() => setActiveTab('enderecos')}
                        >
                            <i className="ti ti-map-pin me-1"></i>
                            Endereços de Entrega
                        </button>
                    </li>
                </ul>
            </div>
            <div className="card-body">
                <div className="tab-content">
                    <div className={`tab-pane fade ${activeTab === 'orcamento' ? 'show active' : ''}`}>
                        <OrcamentoList
                            opportunityId={opportunityId}
                            etapaAtual={etapaAtual}
                            funilAtual={funilAtual}
                            formatCurrency={formatCurrency}
                            onUpdateComplete={handleListaUpdate}
                            refreshKey={listaRefreshKey}
                        />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'detalhes_orcamentos' ? 'show active' : ''}`}>
                        <OrcamentosTab
                            opportunityId={opportunityId}
                            etapaAtual={etapaAtual}
                            funilAtual={funilAtual}
                            formatCurrency={formatCurrency}
                            onUpdateComplete={handleOrcamentosUpdate}
                            refreshKey={outrasAbasRefreshKey}
                        />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'anexos_orcamento' ? 'show active' : ''}`}>
                        <AnexosOrcamentoList opportunityId={opportunityId} refreshKey={outrasAbasRefreshKey} />
                    </div>
                    <div className={`tab-pane fade ${activeTab === 'enderecos' ? 'show active' : ''}`}>
                        <EnderecoEntregaList opportunityId={opportunityId} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrcamentoTabs;